export default __webpack_public_path__ + "static/media/V880_D_BD.924ba35d.pdf";